import { ImageOrientation } from '@space-core/components/customImage/enum'

import styled from 'styled-components'

import { CardOrientation } from './enum'
import BaseImageContainer from './imageContainer'
import type { BaseCardProps } from './types'

import Card from '../../card'

const CardBody = styled(Card.Body)<{ orientation?: CardOrientation; items?: number }>`
  ${({ orientation, items }) =>
    orientation === CardOrientation.HORIZONTAL &&
    `
      display: grid;
      grid-template-columns: minmax(18.75rem, ${items === 1 ? '0.975fr' : '1fr'}) ${
      items === 1 ? '2fr' : '1fr'
    };
      grid-gap: var(--spacer-5);
    `}
`
const DefaultBaseCard = ({
  children,
  coverImage = '',
  avatar = '',
  avatarAltText = '',
  thumbnailImage = '',
  imageAlt = '',
  verticalCoverPage = '',
  verticalAltText = '',
  items = 0,
  orientation = CardOrientation.HORIZONTAL,
  containerOrientation = CardOrientation.HORIZONTAL,
  imageOrientation = ImageOrientation.HORIZONTAL,
  icon,
  iconSize = 'md',
  iconRounded = false,
  tag,
  showDepthEffect = false,
  themeMode,
  freeSignup,
  stylesCustomProductCommunity
}: BaseCardProps) => {
  return (
    <Card className='_rounded _border-0 _bg-transparent' data-test='default-base-card'>
      <CardBody
        orientation={
          imageOrientation === ImageOrientation.HORIZONTAL ? orientation : CardOrientation.VERTICAL
        }
        items={items}
        className='_p-0'>
        <BaseImageContainer
          icon={icon}
          iconSize={iconSize}
          iconRounded={iconRounded}
          imageAlt={imageAlt}
          coverImage={coverImage}
          avatar={avatar}
          avatarAltText={avatarAltText}
          thumbnailImage={thumbnailImage}
          verticalCoverPage={verticalCoverPage}
          verticalAltText={verticalAltText}
          containerOrientation={containerOrientation}
          imageOrientation={imageOrientation}
          tag={tag}
          showDepthEffect={showDepthEffect}
          themeMode={themeMode}
          freeSignup={freeSignup}
          stylesCustomProductCommunity={stylesCustomProductCommunity}
        />
        {children}
      </CardBody>
    </Card>
  )
}

export default DefaultBaseCard
